import React from "react";
import { cn } from "../../../../utils/classnames";

const Bar = ({ className }) => (
  <span className={cn("tw:block tw:h-[16px] tw:animate-pulse tw:rounded-[4px] tw:bg-[#EDEDED]", className)} />
);

const FieldSkeleton = () => (
  <div className="tw:flex tw:flex-col tw:gap-[10px]">
    <Bar className="tw:h-[12px] tw:w-[40%]" />
    <Bar className="tw:w-[75%]" />
  </div>
);

const CardSkeleton = ({ rows = 2, columns = 3 }) => (
  <>
    {/* Section title */}
    <Bar className="tw:mb-4 tw:h-[18px] tw:w-[180px]" />
    <div className="border rounded mb-5 tw:p-4">
      <div className="tw:flex tw:flex-col tw:gap-6">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className="tw:grid tw:grid-cols-1 tw:gap-6 tw:md:grid-cols-2 tw:lg:grid-cols-3"
          >
            {Array.from({ length: columns }).map((_, colIndex) => (
              <FieldSkeleton key={colIndex} />
            ))}
          </div>
        ))}
      </div>
    </div>
  </>
);

const BookingDetailSkeleton = () => (
  <div className="tw:font-hanken-grotesk tw:text-[#212529]">
    {/* Header */}
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-6 tw:pb-[28px] tw:lg:pb-[42px] tw:px-5 tw:pt-8">
      <Bar className="tw:h-[38px] tw:w-[90px] tw:rounded-[5px]" />
      <div className="tw:flex tw:flex-1 tw:items-center tw:justify-between tw:gap-4">
        <div className="tw:flex tw:flex-col tw:gap-[10px]">
          <Bar className="tw:h-[14px] tw:w-[200px]" />
          <Bar className="tw:h-[24px] tw:w-[160px]" />
        </div>
        <Bar className="tw:h-[45px] tw:w-[150px] tw:rounded-[5px]" />
      </div>
    </div>

    <div className="tw:px-5">
      <CardSkeleton rows={1} columns={3} />
      <CardSkeleton rows={2} columns={3} />
      <CardSkeleton rows={1} columns={3} />
      <CardSkeleton rows={2} columns={2} />
    </div>
  </div>
);

export default BookingDetailSkeleton;
